import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleAdapter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-right: auto;
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const InputContent = styled.div`
  ${({ theme }) => css`
    margin: 32px 0 0 0;
    width: 100%;
    max-width: 415px;  

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;  
    }  
  `}
`;

export const InputLabel = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0 0 16px 0;
    display: block;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const TextFieldWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;

  input{
    width: calc(100% - 32px);
  }
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 12px;
  z-index: 10;
`;


export const AutoComplete = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    box-shadow: 1px 1px 5px 0px ${theme.v2.colors.neutral.highMedium};
    height: auto;
    margin: 0;
    max-height: 250px;
    overflow-y: auto;
    padding: 0px;
    position: absolute;
    top: calc(100% + 8px);
    width: 100%;
    padding: 0;
    z-index: ${theme.v2.layers.important};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPrimary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highDark};
      border-radius: 25px;
      height: 30px;
      width: 8px;
    }
  `}
`;

export const AutoCompleteItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    padding: 12px 24px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    &:first-of-type{
      padding-top: 18px;
    }

    &:last-of-type{
      padding-bottom: 18px;
    }

    svg{
      margin: 5px 8px 0 0;
      flex: 0 0 20px;
      width: 20px;

      path{
        stroke: ${theme.v2.colors.neutral.lowMedium};
      }
    }    

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryBlue};

      span{
        color: ${theme.v2.colors.neutral.highPure};        
      }

      svg{
        path{
          stroke: ${theme.v2.colors.neutral.highPure};
        }
      }
    }
  `}
`;

export const AutoCompleteItemCompany = styled.span`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`;

export const AutoCompleteItemCompanyName = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
  `}    
`;

export const AutoCompleteItemCompanyLocation = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.6;
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 32px 0;
`;

export const NotFoundCompany = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.title};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 8px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: break-spaces;
    flex-wrap: wrap;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
